import React, { useEffect, useState } from 'react';
import CommonLayout from "../../layouts/CommonLayout";
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../../store/authStore';

const RicePurchasePage = () => {
    const navigate = useNavigate();
    const authStore = useAuthStore();
    const [isAppEnvironment, setIsAppEnvironment] = useState(false);

    // Flutter 앱에서 접속 시 즉시 네이티브 결제 화면 호출
    useEffect(() => {
        if (window.flutter_inappwebview?.callHandler) {
            setIsAppEnvironment(true);
            // 즉시 네이티브 결제 화면 호출
            window.flutter_inappwebview.callHandler('showPaymentScreen', {
                id: authStore.me?.id,
                token: localStorage.getItem('token'),
            });
        }
    }, [authStore.me?.id]);

    // Flutter 앱에서 접속 시 표시할 로딩 화면
    if (isAppEnvironment) {
        return (
            <CommonLayout title="쌀 충전" onBack={() => navigate('/app/mypage')}>
                <div className="p-4 max-w-md mx-auto text-center space-y-6">
                    <div>
                        <h1 className="text-xl font-bold text-gray-800 mb-2">
                            결제 화면을 불러오는 중
                        </h1>
                    </div>
                </div>
            </CommonLayout>
        );
    }

    // 브라우저에서 접속 시 표시할 안내 화면
    return (
        <CommonLayout title="쌀 충전" onBack={() => navigate('/app/mypage')}>
            <div className="p-4 max-w-md mx-auto text-center space-y-6">
                <img src="/images/rice_1.png" alt="쌀" className="w-12 h-12 mx-auto" />

                <div>
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">
                        밥친구 앱에서 쌀을 구입해주세요
                    </h1>
                    <p className="text-sm text-gray-600">
                        안전하고 편리한 결제를 위해 밥친구 앱을 이용해주세요.<br/>
                        App Store 또는 Google Play에서 밥친구 앱을 다운로드해주세요.
                    </p>
                </div>
            </div>
        </CommonLayout>
    );
};

export default RicePurchasePage;
